var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLabel = function SvgLabel(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 18,
    "data-width-72": 56,
    viewBox: "0 0 19 19",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.387 18.71a2.23 2.23 0 0 0 1.717-.002c.271-.113.517-.279.724-.487l8.79-8.79a.74.74 0 0 0 .22-.56l-.34-7.81a.76.76 0 0 0-.72-.72L9.968 0a.74.74 0 0 0-.56.22L.658 9.04a2.25 2.25 0 0 0 0 3.18l6 6c.208.21.456.376.729.49m.861-1.338a.77.77 0 0 1-.53-.211l-6.03-6.03a.75.75 0 0 1 0-1.06l8.55-8.56 6.8.3.3 6.79-8.56 8.56a.77.77 0 0 1-.53.211m4.745-13.498a2.05 2.05 0 0 1 1.415.567 2 2 0 0 1 0 2.83 2 2 0 0 1-3.416-1.415 2 2 0 0 1 .586-1.415 2.05 2.05 0 0 1 1.415-.567",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLabel);
export default ForwardRef;